import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

import type { UserRead } from "@/lib/api/auth";

interface Tokens {
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  expiresAt: string | null;
  user: UserRead | null;
  permissions: string[];
  setSession: (input: Tokens & { user: UserRead; permissions: string[] }) => void;
  setTokens: (tokens: Tokens) => void;
  setUser: (user: UserRead, permissions: string[]) => void;
  clear: () => void;
  hasPermission: (permission: string) => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      expiresAt: null,
      user: null,
      permissions: [],
      setSession: ({ accessToken, refreshToken, expiresAt, user, permissions }) =>
        set({ accessToken, refreshToken, expiresAt, user, permissions }),
      setTokens: ({ accessToken, refreshToken, expiresAt }) =>
        set({ accessToken, refreshToken, expiresAt }),
      setUser: (user, permissions) => set({ user, permissions }),
      clear: () =>
        set({
          accessToken: null,
          refreshToken: null,
          expiresAt: null,
          user: null,
          permissions: [],
        }),
      hasPermission: (permission) => get().permissions.includes(permission),
    }),
    {
      name: "tibbiy-korik-auth",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        expiresAt: state.expiresAt,
        user: state.user,
        permissions: state.permissions,
      }),
    },
  ),
);
